module.exports = "<style>body,html{background:#fff}</style> <br> <br> <meta name=HandheldFriendly content=True> <meta name=MobileOptimized content=550> <meta name=viewport content=\"width=550,initial-scale=0.76\"/> <br> <canvas style=\"width:100vw;height:100vw;position:absolute;top:calc(50vh - 50vw)\" id=canvas> </canvas> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/view-feedback/feedback.html
// module id = 503
// module chunks = 0